import { Random } from './Utility/Random';
import * as Sentry from '@sentry/browser';
import { IGameState } from './State/Game/IGameState';
// import { Logger } from 'Utility/Logger/Logger';
// import { LogOrigin } from 'Utility/Logger/LogOrigin';
// import { LogStyles } from 'Utility/Logger/LogStyles';

export type ReportTags = Record<string, string | number | boolean>;

export type Categorizer = (
    error: unknown
) =>
    | undefined
    | {
          fingerprint: string;
          tags?: ReportTags;
      };

export const reportedOnce = Object.create(null);
let sentryEnabled = false;

export function setReportEnabledTo(enabled: boolean) {
    sentryEnabled = enabled;
}

export const SENTRY_EXTRA_STATE_DATA_KEY: string = 'redux-state';

export function report(
    message: string,
    extra: {
        error?: unknown;
        sampleRate?: number;
        once?: boolean;
        tags?: ReportTags;
        fingerprint?: string;
        categorizers?: ReadonlyArray<Categorizer>;
        state?: IGameState;
        data?: Record<string, unknown>;
    } = {}
) {
    // let dontReport = false;
    // let fullMessage = message;
    // let hasSampleRate: boolean =
    //     typeof extra.sampleRate === 'number' && !isNaN(extra.sampleRate);
    // if (hasSampleRate && extra.sampleRate < 1) {
    //     fullMessage = `[${extra.sampleRate} sample] ${fullMessage}`;
    //     if (!Random.roll(extra.sampleRate)) {
    //         dontReport = true;
    //     }
    // }
    // if (extra.error) {
    //     // Logger.log(extra.error as Error, LogOrigin.SENTRY, LogStyles.ERROR);
    //     console.error(extra.error);

    //     // TODO: don't meld into message if it has stacktrace
    //     const convertedError = convertError(extra.error);
    //     const { message: errorMessage } = convertedError as any;
    //     if (typeof errorMessage === 'string') {
    //         fullMessage += ': ' + errorMessage;
    //     } else if (typeof convertedError === 'string') {
    //         fullMessage += ': ' + convertedError;
    //     } else {
    //         // TODO: stringify and add to tags?
    //         fullMessage += `: <typeof error=${typeof convertedError}>`;
    //     }
    // }

    // const categorized =
    //     extra.categorizers
    //         ?.map(c => c(extra.error))
    //         .filter(e => e !== undefined) ?? [];

    // let rawTags: ReportTags;
    // for (const c of categorized) {
    //     rawTags = { ...rawTags, ...c.tags };
    // }
    // rawTags = { ...rawTags, ...extra.tags };

    // const tags: Record<string, string> = {};
    // for (const tag in rawTags) {
    //     if (rawTags.hasOwnProperty(tag)) {
    //         tags[tag] = convertToString(rawTags[tag]);
    //     }
    // }

    // if (extra.once) {
    //     const messageWithTags = `${fullMessage} / ${JSON.stringify(tags)}`;
    //     // FIXME: tags are converted through JSON.stringify which doesn't guarantee order
    //     if (reportedOnce[messageWithTags]) return;
    //     reportedOnce[messageWithTags] = true;
    //     fullMessage = `[once] ${fullMessage}`;
    // }

    // const hasTags = Object.keys(tags).length > 0;
    // console.warn(fullMessage, ...(hasTags ? [rawTags] : []));
    // if (!sentryEnabled) return;
    // if (!dontReport) {
    //     const scope = new Sentry.Scope();
    //     if (extra.fingerprint || categorized.length > 0) {
    //         scope.setFingerprint([
    //             extra.once ? 'once' : 'every',
    //             String(hasSampleRate ? extra.sampleRate : 1),
    //             ...(extra.fingerprint ? [extra.fingerprint] : []),
    //             ...categorized.map(c => c.fingerprint),
    //         ]);
    //     }
    //     if (hasTags) {
    //         scope.setTags(tags);
    //     }
    //     if (extra.state) {
    //         scope.setExtra(SENTRY_EXTRA_STATE_DATA_KEY, extra.state);
    //     }
    //     if (extra.data) {
    //         Object.entries(extra.data).forEach(([key, value]) => {
    //             scope.setExtra(key, value);
    //         });
    //     }
    //     Sentry.captureException(new Error(fullMessage), scope);
    // }
}

function convertToString(value: unknown): string {
    if (typeof value == 'string') {
        return value;
    } else {
        return value?.toString?.() ?? '<<n/a>>';
    }
}

export function convertError(error: unknown, optContext?: string): Error {
    if (error instanceof Error) return error;
    const context = optContext ? `${optContext} | ` : '';
    if (!error)
        return new Error(`${context}Falsy error: typeof = ${typeof error}`);
    const { code, message } = error as any;
    let keys = '<n/a>';
    try {
        keys = Object.keys(error as any).join(', ');
    } catch (error) {
        // no action
    }
    return new Error(
        `${context}Error Code ${code}; message = "${message}"; keys = ${keys}`
    );
}

export function assertTypeEquals<T>(
    debugName: string,
    varA: T,
    varB: T,
    expectedType?: string
) {
    const typeA = typeof varA;
    const typeB = typeof varB;
    if (typeA !== typeB || (expectedType && typeA !== expectedType)) {
        report(`Unexpected types for ${debugName}`, {
            once: true,
            tags: { typeA, typeB, expectedType },
        });
    }
}
